/** HTTP-статус ошибки RTK Query; undefined для сетевых и прочих ошибок без статуса. */
export const getApiErrorStatus = (error: unknown): number | undefined => {
  if (typeof error !== 'object' || error === null || !('status' in error)) return undefined;
  const { status } = error as { status: unknown };
  return typeof status === 'number' ? status : undefined;
};

/** Машиночитаемый код ошибки из тела ответа (поле `code` в контракте сервисов v2). */
export const getApiErrorCode = (error: unknown): string | undefined => {
  if (typeof error !== 'object' || error === null || !('data' in error)) return undefined;
  const { data } = error as { data: unknown };
  if (typeof data !== 'object' || data === null || !('code' in data)) return undefined;
  const { code } = data as { code: unknown };
  return typeof code === 'string' ? code : undefined;
};
